import {
  USUARIOS_GET_BUSINESS_UNITS_BEGIN,
  USUARIOS_GET_BUSINESS_UNITS_SUCCESS,
  USUARIOS_GET_BUSINESS_UNITS_FAILURE,
  USUARIOS_GET_BUSINESS_UNITS_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW } from '../../../common/config';
const BU_SAVINGS_PLAN_NAME = "Plan de ahorro"

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getBusinessUnits(getSavingsPlanUnit) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: USUARIOS_GET_BUSINESS_UNITS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API_ABM_FW + "/UnitBussiness");
      doRequest.then(
        (res) => {
          const units = getSavingsPlanUnit ? res.data.data : res.data.data.filter(item => item.Name !== BU_SAVINGS_PLAN_NAME)
          const sanitizedUnits = units.map((item) => {
            return { value: item.id, label: item.Name, checked: false }
          });
          dispatch({
            type: USUARIOS_GET_BUSINESS_UNITS_SUCCESS,
            data: sanitizedUnits,
          });
          resolve(sanitizedUnits);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USUARIOS_GET_BUSINESS_UNITS_FAILURE,
            data: { error: err },
          });
          reject([]);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetBusinessUnitsError() {
  return {
    type: USUARIOS_GET_BUSINESS_UNITS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USUARIOS_GET_BUSINESS_UNITS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getBusinessUnitsPending: true,
        getBusinessUnitsError: null,
      };

    case USUARIOS_GET_BUSINESS_UNITS_SUCCESS:
      // The request is success
      return {
        ...state,
        getBusinessUnitsPending: false,
        getBusinessUnitsError: null,
        business_units: action.data
      };

    case USUARIOS_GET_BUSINESS_UNITS_FAILURE:
      // The request is failed
      return {
        ...state,
        getBusinessUnitsPending: false,
        getBusinessUnitsError: action.data.error,
        business_units: []
      };

    case USUARIOS_GET_BUSINESS_UNITS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getBusinessUnitsError: null,
      };

    default:
      return state;
  }
}
